<table class="specifikation">
    @for (row of getDisplayRows(); track $index) {
        @if (isMoreGroupRow(row)) {
            <tr class="mere-knap">
                <td colspan="2">
                    @if (row.isExpanded) {
                        <a (click)="toggleMore(row.groupKey)">vis mindre</a>
                    } @else {
                        <a (click)="toggleMore(row.groupKey)">vis mere... ({{ row.hiddenCount }})</a>
                    }
                </td>
            </tr>
        } @else {
            <tr [class]="row.cssClasses">
                <td>{{ row.tekst }} <small [innerHTML]="row.tekst2"></small></td>
                <td>{{ row.beloeb | number: "1.0-0" }} {{ row.beloebSuffix }}</td>
            </tr>
        }
    }
</table>
